import { allPass, has, propEq } from "ramda";
import { ILocationFilter, ISearchFilter } from "../typings";

export default allPass<(x: ISearchFilter) => boolean>([
  propEq("search-location-id", "id"),
  has("location"),
]) as (x: ISearchFilter) => x is ILocationFilter;
